import { privateAxios } from "@/common/api/axios";
import { UseMutationResult, useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { EditEquipmentUsageValidationSchema } from "../schemas/editEquipmentUsage.schema";
import { unFormatUnknownUnit } from "@/common/utils/unFormatters";

interface useUpdateEquipmentUsageOptions {
  equipmentId: string;
  categoryId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void,
}

const useUpdateEquipmentUsage = ({ equipmentId, categoryId, onSuccess, onError }: useUpdateEquipmentUsageOptions): UseMutationResult<void, Error, EditEquipmentUsageValidationSchema> => {
  return useMutation({
    mutationFn: async ({ value, reason, file }: EditEquipmentUsageValidationSchema) => {
      await privateAxios.postForm(`/equipments/${equipmentId}/last_usage_declaration`, {
        last_usage_declaration: {
          value: value ? unFormatUnknownUnit(value) : undefined,
          reason,
          file,
          category_id: categoryId,
        }
      });
    },
    onSuccess,
    onError
  });
};

export default useUpdateEquipmentUsage;
